export const ADD_IPO_RENEWALS = [100000006, 100000003, 100000004, 100000008, 100000009];

export enum RenewalType {
  AddPlan = 100000006,
  NewPlan = 100000003,
  NewCarrier = 100000004,
  RateChange = 100000008,
  RateAndPlanChange = 100000009,
  NoChange = 100000002,
  NumberChange = 100000007,
}

export enum ProductType {
  GAP = "GAP",
  LM = "LM",
  MEC = "MEC",
}

export enum AgeBand {
  UnderForty = "under_40",
  FortyToFortyNine = "40_49",
  OverFifty = "over_50",
}
export enum Tier {
  Employee = "Employee",
  EmployeeSpouse = "Employee/Spouse",
  EmployeeChild = "Employee/Child(ren)",
  Family = "Family",
  EmployeePlusOne = "Employee Plus One",
}

export enum RateType {
  Composite = "Composite",
  AgeBanded = "Age_Banded",
}

export interface GroupRenewalTier {
  tier: Tier;
  price: string;
  ageBand?: AgeBand;
}

export interface GroupRenewalIPO {
  name: string;
  tiers: GroupRenewalTier[];
  previousYearIPO?: GroupRenewalIPO;
  rateType: RateType;
  productType: ProductType;
}

export interface GroupRenewal {
  name: string;
  address1: string;
  address2: string | null;
  city: string;
  state: string;
  zip: string;
  groupId: string;
  renewalDate: string;
  increasePercentage?: string;
  currentIpos: GroupRenewalIPO[];
  type: ProductType[];
  renewalType: RenewalType;
}
